import React, { useState, useEffect } from 'react';

import notaire from './../../../assets/images/svg/004-A-notaire.png';
import securitesociale from './../../../assets/images/svg/004-A-securitesocial.png';
import banque from './../../../assets/images/svg/004-A-banque.svg';
import mutuelle from './../../../assets/images/svg/004-A-mutuelle.svg';
import assurance from './../../../assets/images/svg/100-assurance.svg';
import fournisseureau from './../../../assets/images/svg/004-A-fournisseureau.svg';
import fournisseurelectricite from './../../../assets/images/svg/004-A-fournisseurelectricite.svg';
import telephonemobile from './../../../assets/images/svg/004-A-telephonemobile.svg';
import centreimpots from './../../../assets/images/svg/004-A-dgfip.png';

import sport from './../../../assets/images/svg/004-B-sport.svg';
import internet from './../../../assets/images/svg/004-B-internet.svg';
import loisirs from './../../../assets/images/svg/004-B-loisirs.svg';
import voitures from './../../../assets/images/svg/004-B-voiture.svg';
import transport from './../../../assets/images/svg/004-B-transport.svg';
import entretienmaison from './../../../assets/images/svg/004-B-entretienmaison.svg';
import securite from './../../../assets/images/svg/004-B-securite.svg';
import soinesthetique from './../../../assets/images/svg/004-B-soinesthetique.svg';
import domicile from './../../../assets/images/svg/004-B-domicile.svg';
import musique from './../../../assets/images/svg/004-B-musique.svg';
import cartepaiment from './../../../assets/images/svg/004-B-cartepaiment.svg';
import multimedia from './../../../assets/images/svg/004-B-multimedia.svg';
import tech from './../../../assets/images/svg/004-B-tech.svg';
import tv from './../../../assets/images/svg/004-B-tv.svg';
import solidaire from './../../../assets/images/svg/004-B-solidaire.svg';
import autres from './../../../assets/images/svg/004-B-autres.svg';

import reseauxsociaux from './../../../assets/images/svg/104-social-media.svg';
import loisir from './../../../assets/images/svg/029-football-ball.svg';
import pet from './../../../assets/images/svg/028-pet-food.svg';
import mobile from './../../../assets/images/svg/024-furniture.svg';
import personnes from './../../../assets/images/svg/024-account.svg';
import duo from './../../../assets/images/svg/088-duo.svg';

export const HistoriqueProfile = () => {
	//We should get it from backend!
	function service(title, icon, progress) { return { title: title, icon: icon, progress: (progress === undefined ? 0 : progress) } };
	function doc(firstTitle, secondTitle, num, actions) { return { firstTitle: firstTitle, secondTitle: secondTitle, num: num, actions: actions } };
	const [userServices, setUserServices] = useState([
		service('notaire', notaire, 100), service('sport', sport, 100), service('internet', internet, 0), service('fournisseur d\'électricité', fournisseurelectricite, 100),
		service('téléphone mobile', telephonemobile, 100), service('banque', banque, 100), service('multimedia', multimedia, 100), service('dissolution du pacs', securitesociale, 100),
		service('centre des impôts', centreimpots, 100), service('musique', musique, 100), service('mutuelle', mutuelle, 100), service('voiture', voitures, 100),
		service('assurance', assurance, 100), service('fournisseur d\'eau', fournisseureau, 100), service('loisirs', loisirs, 100), service('titre de transport', transport, 100),
		service('entretien maison', entretienmaison, 100), service('sécurité', securite, 100), service('SOIN ET ESTHETIQUE', soinesthetique, 100), service('Services a domicile', domicile, 100),
		service('CARTE DE PAIEMENT', cartepaiment, 100), service('Technology', tech, 100), service('TÉLÉVISION', tv), service('solidarité', solidaire, 100),
		service('autres', autres, 100), service('reseaux sociaux', reseauxsociaux, 100), service('loisirs', loisir), service('animaux', pet, 100),
		service('MATERIEL / MOBILE', mobile), service('personnes', personnes, 100), service('duo', duo, 100)
	]);
	const [userDocuments, setUserDocuments] = useState([doc('documents', 'personnels', 0, 4), doc('documents', 'mandataire', 0, 3), doc('démarches', 'communes', 3, 10), doc('démarches', 'personnalisées', 4, 20)]);

	return (
		<div className="modal fade px-0" id="HistoriqueProfile" aria-labelledby="HistoriqueProfileLabel" aria-hidden="true">
			<div className="modal-dialog px-2 modal-dialog-scrollable">
				<div className="modal-content">
					<header className="modal-header flex-column">
						<div className="alert bg-alert-secondary rounded-bottom-right-sm rounded-top-left-sm w-100 text-center mb-0">
							<h1 className="sr-only visually-hidden">User Historique</h1>
							<div className="flex-row align-items-center justify-content-between">
								<div className="h4 text-secondary text-uppercase mb-0 font-weight-bolder ls-n1 lh-1 mx-auto" id="HistoriqueProfileLabel">Historique</div>
								<button type="button" className="btn btn-close btn-icon p-0 mr-0" data-dismiss="modal" aria-label="Close">
									<i className="eva eva-close fs-4"></i>
								</button>
							</div>
						</div>
						<div className="container-tight mt-2 mx-auto input-group btn-dim rounded-max btn-alert active dropdown" role="button">
							<p className="form-control bg-none border-none rounded-inherit my-auto small" id="recentsHToggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Les plus récents</p>
							<div className="input-group-prepend rounded-inherit" id="recentsToggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
								<button type="button" className="input-group-text btn btn-icon border-left-0 border-none rounded-inherit m-1 w-4">
									<i className="eva eva-funnel-outline align-middle fs-root lh-0 o-70 o-100--hover"></i>
								</button>
							</div>
							<div className="dropdown-menu border-none shadow" aria-labelledby="recentsHToggle">
								<button className="dropdown-item py-2 h6 mb-0 active" type="button">Les plus récents</button>
								<button className="dropdown-item py-2 h6 mb-0" type="button">Ordre alphabétique</button>
							</div>
						</div>
					</header>
					<div className="modal-body scroll-default py-0 mr-4 pr-0">
						<div className="accordion" id="accordionHistory">
							<section className="block">
								<h2 className="h6 text-secondary text-uppercase font-weight-demi my-auto">Vendredi, 24 août 2020</h2>
								<div className="card">
									<div className="card-header px-2 pt-2 pb-0" id="heading1" role="button">
										<div className="flex-row align-items-center justify-content-lg-between" data-toggle="collapse" data-target="#accordion1" aria-expanded="true" aria-controls="accordion1">
											<h2 className="fs-3 my-auto"><i className="eva eva-bell-outline fs-sm align-middle mr-1 o-60"></i><span className="align-middle font-weight-demi mr-1">Alerte envoyée au mandataire</span><span className="align-middle font-weight-base">-  12:07</span></h2>
											<button type="button" className="btn btn-icon p-0 text-uppercase font-weight-demi fs-4 my-auto ml-auto m-lg-1 o-30" name="refPrincipal"><i className="eva eva-arrow-ios-downward-outline"></i></button>
										</div>
										<hr className="my-0 border-gray" />
									</div>
									<div className="card-body p-2 collapse show" id="accordion1" aria-labelledby="heading1" data-parent="#accordionHistory">
										<div className="card card-body rounded bg-dim">
											<form className="grid-sm grid-sm-min grid-lg-tight grid-lg-4" noValidate>
												{/* show the history of actions for the user */}
												{
													userServices.map((s, index) => {
														return (
															(s.progress !== 100) ?
																<div key={index} className="form-group mb-lg-0">
																	<div className="card rounded p-2 text-center picker-card paper-shadow--hover border-none">
																		<div className="card-column" data-toggle="modal" data-target="#previewDoc">
																			<img className="img-fluid mx-auto my-3 mb-2 h-6 py-1" src={s.icon} alt={s.title} />
																			<h3 className={"h6 text-uppercase font-weight-bolder" + (s.progress === 100 ? ' my-auto' : ' container-tight mx-auto mt-auto')}>{s.title}</h3>
																			<p className={"small font-weight-demi mt-auto lh-copy o-70 mb-2"}>Envoyer jusqu'au jour</p>
																			<div className={"progress position-relative w-100 text-center h-4 rounded-max align-items-center" + (s.progress === 100 ? ' bg-white' : ' bg-common 0')}>
																				<div className={"progress-bar h-100 rounded-inherit o-20" + (s.progress === 100 ? ' bg-secondary' : ' gradient-prime')} style={{ width: `${s.progress}%` }} role="progressbar"></div>
																				<div className={"h5 d-flex position-absolute m-auto justify-content-center w-100 font-weight-bolder" + (s.progress === 100 ? ' text-secondary' : ' text-danger')} role="progressbar">14/07/2020</div>
																			</div>
																		</div>
																		<hr className="w-100 my-2 border-faded" />
																		<div className="grid grid-2">
																			<button type="button" className="btn btn-icon p-0 align-middle o-80 o-100--hover mx-auto" data-toggle="tooltip" data-placement="top" data-html="false" title="Sélectionner"><i className="eva eva-square-outline align-middle fs-root"></i></button>
																			<button type="button" className="btn btn-icon p-0 align-middle o-80 o-100--hover mx-auto"><i className="eva eva-download-outline align-middle fs-root"></i></button>
																		</div>
																	</div>
																</div>
																:
																''
														);
													})
												}
											</form>
										</div>
									</div>
								</div>
							</section>
							<section className="block mt-4">
								<h2 className="h6 text-secondary text-uppercase font-weight-demi my-auto">Vendredi, 22 août 2020</h2>
								<div className="card">
									<div className="card-header px-2 pt-2 pb-0" id="heading2" role="button">
										<div className="flex-row align-items-center justify-content-lg-between" data-toggle="collapse" data-target="#accordion2" aria-expanded="false" aria-controls="accordion1">
											<h2 className="fs-3 my-auto"><i className="eva eva-email-outline fs-sm align-middle mr-1 o-60"></i><span className="align-middle font-weight-demi mr-1">E-mail envoyé</span><span className="align-middle font-weight-base">  -  10:56</span></h2>
											<button type="button" className="btn btn-icon p-0 text-uppercase font-weight-demi fs-4 my-auto ml-auto m-lg-1 o-30" name="refPrincipal"><i className="eva eva-arrow-ios-downward-outline"></i></button>
										</div>
										<hr className="my-0 border-gray" />
									</div>
									<div className="card-body p-2 collapse" id="accordion2" aria-labelledby="heading2" data-parent="#accordionHistory">
										<div className="card card-body rounded bg-dim">
											<form className="grid-sm grid-sm-min grid-lg-tight grid-lg-4" noValidate>
												{/* show the history of actions for the user */}
												{
													userServices.map((s, index) => {
														return (
															(s.progress !== 100) ?
																<div key={index} className="form-group mb-lg-0">
																	<div className="card rounded p-2 text-center picker-card paper-shadow--hover border-none">
																		<div className="card-column" data-toggle="modal" data-target="#previewDoc">
																			<img className="img-fluid mx-auto my-3 mb-2 h-6 py-1" src={s.icon} alt={s.title} />
																			<h3 className={"h6 text-uppercase font-weight-bolder" + (s.progress === 100 ? ' my-auto' : ' container-tight mx-auto mt-auto')}>{s.title}</h3>
																			<p className={"small font-weight-demi mt-auto lh-copy o-70 mb-2"}>Envoyer jusqu'au jour</p>
																			<div className={"progress position-relative w-100 text-center h-4 rounded-max align-items-center" + (s.progress === 100 ? ' bg-white' : ' bg-common 0')}>
																				<div className={"progress-bar h-100 rounded-inherit o-20" + (s.progress === 100 ? ' bg-secondary' : ' gradient-prime')} style={{ width: `${s.progress}%` }} role="progressbar"></div>
																				<div className={"h5 d-flex position-absolute m-auto justify-content-center w-100 font-weight-bolder" + (s.progress === 100 ? ' text-secondary' : ' text-danger')} role="progressbar">14/07/2020</div>
																			</div>
																		</div>
																		<hr className="w-100 my-2 border-faded" />
																		<div className="grid grid-2">
																			<button type="button" className="btn btn-icon p-0 align-middle o-80 o-100--hover mx-auto" data-toggle="tooltip" data-placement="top" data-html="false" title="Sélectionner"><i className="eva eva-square-outline align-middle fs-root"></i></button>
																			<button type="button" className="btn btn-icon p-0 align-middle o-80 o-100--hover mx-auto"><i className="eva eva-download-outline align-middle fs-root"></i></button>
																		</div>
																	</div>
																</div>
																:
																''
														);
													})
												}
											</form>
										</div>
									</div>
									</div>
							</section>
						</div>

					</div>
					<div className="modal-footer">
						<button type="button" className="btn btn-faded" data-dismiss="modal">Fermer</button>
					</div>
				</div>
			</div>
		</div>
	)
}